import Immutable from 'immutable';

const initialStateValue = {
  data_ready: false,
  data: [],
  receipt: {},
  lastUpdated: '',
  error: {},
};

const initialState = Immutable.fromJS(initialStateValue);


const actionHandlers = {
  REQUEST_CASE_DATA: state =>
    state.mergeDeep(initialStateValue),

  RECEIVE_CASE_DATA: (state, action) => {
    const s = state.set('data', []).mergeDeep({
      data_ready: true,
      data: action.data,
      lastUpdated: action.lastUpdated,
      receipt: action.receipt,
    });
    return s;
  },

  SERVICE_ERROR: (state, action) => state.mergeDeep({ data_ready: true, error: action.errors }),
};

export default (state = initialState, action) => {
  const actionHandler = actionHandlers[action.type];

  return (actionHandler)
    ? actionHandler(state, action)
    : state;
};



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/irSearch.js
 **/